interface CompanyLogoProps {
  logoUrl: string | null | undefined
  altText?: string
  isCollapsed?: boolean
  maxHeight?: string
  className?: string
}

const CompanyLogo: React.FC<CompanyLogoProps> = ({
  logoUrl,
  altText = 'Company logo',
  isCollapsed = false,
  maxHeight = '48px', // Match the default SVG height
  className = '',
}) => {
  if (!logoUrl) {
    return null
  }

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>): void => {
    const target = e.target as HTMLImageElement
    target.style.display = 'none'
    console.error('Failed to load logo:', logoUrl)
  }

  return (
    <div
      className={`
        relative
        flex
        w-auto
        items-center
        justify-center
        ${className}
      `}
    >
      <img
        src={logoUrl}
        alt={altText}
        className="
          w-auto
          object-contain
          transition-all
          duration-200
          ease-in-out
          hover:opacity-90
        "
        style={{ maxHeight }}
        onError={handleImageError}
      />
    </div>
  )
}

export default CompanyLogo
